<div class="message-modal">
    <img [src]="image" alt="" aria-hidden="true" class="header-image">
    <h1 class="title" id="modal-title">{{ title }}</h1>
    <p class="body">{{ text }}</p>
    <div class="action">
        <button (click)="cancel()" class="button">{{ btnCancel }}</button>
        <button (click)="ok()" class="button primary">{{ btnAccept }}</button>
    </div>
</div>
